import { CSSProperties, PropsWithChildren } from "react";

type Props = PropsWithChildren<object>;

export default function ProductCardsContainer({ children }: Props) {
  const styles: CSSProperties = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
    gap: "var(--spacing-3xl)",
  };

  return <div style={styles}>{children}</div>;
}
